import timezones from 'google-timezones-json';
import React, {FC, ReactNode} from 'react';

import {HandlerOf, RendererOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {DropdownList} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {PopoverTransferProps} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';

/*
 * Props.
 */

interface TimezoneDropdownBoxProps {
  timezone: string;
  onTimezoneSelect: HandlerOf<string>;
  className?: string;
  label?: ReactNode;
  renderItem?: RendererOf<string>;
}

/*
 * Component.
 */

export const TimezoneDropdownBox: FC<TimezoneDropdownBoxProps> = (props) => {
  const renderDropdownItem = props.renderItem ?? renderItem;

  return (
    <DropdownBoxCoordinator
      value={renderDropdownItem(props.timezone)}
      renderDropdown={(popoverProps) => renderDropdown(popoverProps, props)}
      boxClassName={props.className}
      label={props.label}
    />
  );
};

function renderDropdown(popoverProps: PopoverTransferProps, props: TimezoneDropdownBoxProps) {
  return (
    <Dropdown {...popoverProps} maxHeight={300}>
      {renderDropdownContent(popoverProps, props)}
    </Dropdown>
  );
}

function renderDropdownContent(popoverProps: PopoverTransferProps, props: TimezoneDropdownBoxProps) {
  const renderDropdownItem = props.renderItem ?? renderItem;

  return (
    <DropdownList {...popoverProps}>
      {Object.keys(timezones).map((timezone) => {
        const isChecked = timezone === props.timezone;
        return (
          <DropdownItem
            key={timezone}
            isChecked={isChecked}
            onSelect={() => props.onTimezoneSelect(timezone)}
          >
            <DropdownItemContent isChecked={isChecked}>{renderDropdownItem(timezone)}</DropdownItemContent>
          </DropdownItem>
        );
      })}
    </DropdownList>
  );
}

/*
 * Helpers.
 */

function renderItem(timezone: string) {
  return timezones[timezone] ?? null;
}
